module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAhCAYAAAAoNdCeAAABSklEQVRIS2NkYGBgeKspbcHK/P84iE0NwHflGSM2c8CCn3Sk/rOcukMNexj+mKmAzcFmISM1LYK5FpeFNLEMZCk2C2lmGTYLaWoZuoUkWwYKHlITEyxISbYM5lpyLBy1DJ7hYeFPl2AkJ4HA4pnkOBsQn5HqQ5B6knyGzQKYT0FBhS8eybIM3VBkB/z//Inhb18LA0t9F0YNQrRlf8qyGBgO7CLocny+I9qy/+/eMvz1MCe5mEL2HtGWkZoYsNXCBC37Y67KwPD/P0U+Qq5QSUqNlLQbCPqMEsPR9Q4+y2xsbMCOZGRkZDh8+DADjH/kyBGwOIwPYsPEyEogMMNAhoAMxUcTCnKigpGQJTTxGczluCynqs/oYhkhFxMrT1ScEWsYIXX0twzkIlp0LtBLfFCvBtJl0pUqZ/jP0EEoKMiVZ2T858B7+cVBAIlJOpDlnVX5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img-icons/pdf.png
// module id = +l+M
// module chunks = 2